import axiosInstance from '@/libs/axios_config.ts'
import { parseRequestError } from '@/common/utilities.ts'
import { RequestResponse } from '@/common/types_and_interfaces.ts'
import { z } from 'zod'

const GetTransferScholarStatusSchema = z.object({
  email: z.string(),
  transfer_status: z.enum(['complete', 'incomplete']),
})
type GetTransferScholarStatus = z.infer<typeof GetTransferScholarStatusSchema>
export async function getTransferScholarStatus(
  externalApplicantId: string,
  simulateTransfer: boolean,
  callbackUrl?: string
): Promise<RequestResponse<GetTransferScholarStatus>> {
  try {
    const response = await axiosInstance.get('/transfer_scholars/status', {
      params: {
        external_applicant_id: externalApplicantId,
        call_back_url: callbackUrl,
        simulate: simulateTransfer,
      },
    })
    return {
      data: GetTransferScholarStatusSchema.parse(response.data),
      error: null,
    }
  } catch (e) {
    return {
      data: null,
      error: parseRequestError(e),
    }
  }
}

const ResendTransferScholarEmailInvitationSchema = z.object({
  msg: z.string(),
})

type ResendTransferScholarEmailInvitation = z.infer<
  typeof ResendTransferScholarEmailInvitationSchema
>

export async function resendTransferScholarEmailInvitation(
  externalApplicantId: string,
  callbackUrl?: string
): Promise<RequestResponse<ResendTransferScholarEmailInvitation>> {
  try {
    const response = await axiosInstance.post(
      '/transfer_scholars/resend_email_invitation',
      {
        external_applicant_id: externalApplicantId,
        call_back_url: callbackUrl,
      }
    )
    return {
      data: ResendTransferScholarEmailInvitationSchema.parse(response.data),
      error: null,
    }
  } catch (e) {
    return {
      data: null,
      error: parseRequestError(e),
    }
  }
}
